import { render } from "./BaseCombo.vue?vue&type=template&id=37c6a1de&scoped=true&lang=pug"
import script from "./BaseCombo.vue?vue&type=script&lang=js"
export * from "./BaseCombo.vue?vue&type=script&lang=js"

import "./BaseCombo.vue?vue&type=style&index=0&id=37c6a1de&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c6a1de"]])

export default __exports__